import { sdk } from '@needful-things-mvp/sdk';

import { USE_MOCK } from './data-mode';
import { unwrap } from './http';
import { delay } from './mock';

export type UserRole = 'admin' | 'user';
export type UserStatus = 'active' | 'inactive' | 'banned';

export interface Me {
  id: string;
  name: string | null;
  email: string;
  picture: string | null;
  role: UserRole;
  status: UserStatus;
}

export interface MeInput {
  name?: string;
  picture?: string;
}

let me: Me = {
  id: 'ana',
  name: 'Ana Souza',
  email: 'ana@needfulthings.com',
  picture: null,
  role: 'admin',
  status: 'active',
};

/** `GET /admin/me` — the authenticated member. */
export async function getMe(): Promise<Me> {
  if (USE_MOCK) {
    await delay();
    return me;
  }
  return unwrap<Me>(await sdk.api.admin.me.get());
}

/** `PATCH /admin/me`. */
export async function updateMe(input: MeInput): Promise<Me> {
  if (USE_MOCK) {
    await delay();
    me = { ...me, ...input };
    return me;
  }
  return unwrap<Me>(await sdk.api.admin.me.patch(input));
}
